'use strict';
var I18n, Optimize, config, options;

window._ = require('underscore');

require('../../../src/frontend/vendor/md5');

require('../../../src/frontend/vendor/cookie');

require('../groupon_modules/modernizr-hacks');

I18n = require('../../../node_modules/grapefruit/lib/I18n');

options = $(document.head).data();

window.I18n = new I18n(options);

require('optimize-suite');

require('../../../src/frontend/vendor/eventPause-custom');

require('jquery.finger');

Optimize = window.Optimize;

config = Optimize.suiteData.config;

config.finch = {
  config: Optimize.finchConfig
};

Optimize.config = config;

OptimizeSuite.init(config);

